<script lang="ts" setup>
import ButtonBasic from './ButtonBasic.vue';
import type { IButtonCompProps } from './PropInterfaces';

const props = withDefaults(defineProps<IButtonCompProps>(), {
    buttonType: 'Primary',
    iconPosition: 'left',
    textposition: 'center',
    hideTextOnMobile: false,

    loadstate: null,
});

export type ButtonTypes =
    | 'Primary'
    | 'Secondary'
    | 'Tertiary'
    | 'Success'
    | 'Danger'
    | 'Warning'
    | 'Info'
    | 'Link'
    | 'Custom'
    | 'Save'
    | 'Close'
    | 'Search'
    | 'Delete'
    | 'Edit'
    | 'Add'
    | 'Refresh';

const buttonClassMap = new Map<ButtonTypes, string>([
    ['Primary', 'btn-primary btn-submit'],
    ['Secondary', 'btn-secondary'],
    ['Success', 'btn-success'],
    ['Danger', 'btn-danger'],
    ['Warning', 'btn-warning'],
    ['Info', 'btn-info'],
    ['Link', 'btn-link'],
    ['Custom', 'btn-custom'],
    ['Save', 'btn-primary btn-save btn-submit'],
    ['Close', 'btn-secondary'],
    ['Search', 'btn-primary'],
    ['Delete', 'btn-danger'],
    ['Edit', 'btn-secondary'],
    ['Add', 'btn-secondary'],
    ['Refresh', 'btn-secondary'],
    ['Tertiary', 'btn-tertiary bg-tertiary'],
]);

const buttonIconMap = new Map<ButtonTypes, string>([
    ['Save', 'fa-save'],
    ['Close', 'fa-times'],
    ['Search', 'fa-search'],
    ['Delete', 'fa-trash-xmark'],
    ['Edit', 'fa-edit'],
    ['Add', 'fa-plus'],
    ['Refresh', 'fa-sync'],
]);

const iconPositionMap = new Map<string, 'left' | 'right'>([
    ['Save', 'left'],
    ['Close', 'left'],
    ['Search', 'left'],
    ['Delete', 'left'],
    ['Edit', 'left'],
    ['Add', 'left'],
    ['Refresh', 'left'],
]);
</script>

<template>
    <ButtonBasic
        :icon="icon || buttonIconMap.get(buttonType)"
        :iconFamily="iconFamily"
        :iconPosition="iconPosition || iconPositionMap.get(buttonType)"
        :class="buttonClassMap.get(buttonType)"
        :textposition="textposition"
        :hideTextOnMobile="hideTextOnMobile"
        :loadstate="loadstate"
        :disabled="loadstate?.isActive || disabled"
        :title="props.title ? $tm(props.title) : undefined"
    >
        <slot></slot>
    </ButtonBasic>
</template>
